/** Metadata for keyset search requests/responses shared across grids. */

/** Default keyset cap for member/task grids (when their APIs define a lower max). */
export const KEYSET_MAX_PAGE_SIZE = 100;

/** Case keyset cap — matches {@code CaseSearchKeysetRequest.MAX_PAGE_SIZE} on the server. */
export const CASE_KEYSET_MAX_PAGE_SIZE = 1000;

/** Page-size choices for simplified (keyset) member/task grids. */
export const KEYSET_PAGE_SIZES: readonly number[] = [5, 10, 25, 50, 100];

export function clampKeysetPageSize(size: number, maxPageSize = KEYSET_MAX_PAGE_SIZE): number
{
  return Math.min(maxPageSize, Math.max(1, size));
}

export type KeysetNavigationDirection = 'NEXT' | 'PREV' | 'LAST';

export type KeysetRequestMode = 'FIRST' | 'NAV_NEXT' | 'NAV_PREV' | 'NAV_LAST';

export interface KeysetPagingMeta
{
  requestNavigationDirection: KeysetNavigationDirection;
  requestSize: number;
  hadRequestCursor: boolean;
  requestMode: KeysetRequestMode;
}

export interface KeysetPagingResponseFlags
{
  hasMore: boolean;
  hasPrevious: boolean;
  nextCursor: any | null;
  previousCursor: any | null;
}

/** Incoming row metadata emitted with grid data after a keyset POST. */
export type KeysetPagingResultMeta = KeysetPagingMeta & KeysetPagingResponseFlags;

/** Wire JSON from POST `{resource}/search/keyset` (data rows, total, cursor flags). */
export interface KeysetGridSearchHttpResponse
{
  data?: any[];
  total?: number;
  hasMore?: boolean;
  hasPrevious?: boolean;
  nextCursor?: any;
  previousCursor?: any;
}
